// Global Constants for ALL Open Modules 
export default {
  inputDateFormat: 'YYYY-MM-DD',
  displayDateFormat: 'MMM DD, YYYY',
  displayTimeFormat: 'HH:mm:ss.SSS', 

  PopUpMaxWidth: 400,
  IE: "IE",
  IECountryCode: 353,
  UK: "UK",
  UKCountryCode: 44,
  IECountryName: "Ireland",
  UKCountryName: "United Kingdom"
};